import { rem } from 'polished'
import styled from 'styled-components'

const DividerStyling = styled.hr`
  border: none;
  border-top: 1px solid ${props => props.theme.palette.neutral.default.six};
  margin: ${rem(20)} 0;
`

function Divider() {
  return <DividerStyling />
}

export default Divider
